
import barba from '@barba/core';
import Chart from 'chart.js'

export default class{

	constructor(){
        barba.hooks.afterOnce(() => {
            this.intro()
        });
        barba.hooks.after(() => {
            this.intro()
        });
    }
    
    intro (){
        const canvas =  document.querySelectorAll('[data-pie-chart]')
        
        if(canvas.length > 0){
            canvas.forEach( (el)  => {
                let chart = ""
                const id = el.getAttribute("id");
                const ctx = document.getElementById(id).getContext('2d');
                const position = el.getAttribute("data-position");
                const data = el.getAttribute("data-chart-data").split("|");
                const backgroundColor = el.getAttribute("data-background").split("|");
                const labels = el.getAttribute("data-labels").split("|");
                
                
                const datas = {
                    datasets: [{
                        data: data,
                        backgroundColor: backgroundColor,
                    }],
                    labels: labels
                };

                chart = new Chart(ctx, {
                    type: 'pie',
                    data: datas,
                    options: {
                        responsive: true,
                        legend: {
                            position:position
                        },
                        tooltips:{
                            callbacks: 
                            {
                                label: function(tooltipItem, data) {
                                    let label = data.labels[tooltipItem.index] || '';
                                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]|| '';
                                    if (label) {
                                        label += ' : ';
                                    }
                                    label += value + "%";
                                    return label;
                                },
                            }
                        }
                    }
                });
                const resizeEvent = () => {
                    if(position == "right"){
                        if(window.outerWidth <= 768){
                            chart.options.legend.display=false;
                        }else{
                            chart.options.legend.display=true;
                        }
                        chart.update()
                    }
                }
                window.addEventListener("resize",resizeEvent)
                resizeEvent();
            })
        }
    }
}